module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/hero-small.18b0e95795062cde5ce9ae7ecfa2654b.jpg";